import { fetchComponentData } from './actions';
import c from 'common/constants/flux-events';

const initMw = () => ({ dispatch, getState }) => next => async action => {
    next(action);
    const re = /\/campaigns\/[0-9]*\/(report|client-report)/
    const isReportPage = re.test(window.location.pathname);

    const reFTA = /foot-traffic-attribution/;
    const isFTAPage = reFTA.test(window.location.pathname);
    // Header "Use new report table" dispatches NEW_REPORTING_PREFERENCE__CHANGED.
    // Same refetch as changeView so Geo POSTs /report with the current preference.
    if (
        (action.type === 'campaignPageContainer:changeView' ||
            action.type === c.CAMPAIGN_REPORT__NEW_REPORTING_PREFERENCE__CHANGED) &&
        isReportPage &&
        !isFTAPage
    ) {
        const campaignId = getState().campaignPageContainer.campaign.id;
        fetchComponentData(campaignId, dispatch, getState);
    }
};

export const makeMiddlewares = deps => {
    return [initMw(deps)];
};
export const middlewares = makeMiddlewares({});
